import { Component, OnInit } from '@angular/core';
import { SecuritymenuService } from '../../../services/securitymenu.service';
import { BaseService } from '../../../base.service';
import { UserService } from '../../../services/user.service';
import { User } from '../../../models/user';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.css']
})
export class NavComponent implements OnInit {

  title: string;
  links: any;
  selected: any;
  user_data: User;

  currentItem: number = null;

  constructor(
    private baseService: BaseService,
    private securitymenuService: SecuritymenuService,
    private userService: UserService
  ) {}

  ngOnInit(): any {
    this.user_data = {
      id: null,
      email: '',
      name: '',
      lastName: '',
      phone: '',
      dni: '',
      creationDate: null,
      status: null,
      creationUser: null,
      role: '',
      fullName: ''
    };

    this.securitymenuService.getAll()
    .subscribe(data => {
      if (data) {
        this.links = data;
      }
    });

    this.userService.getUserMe()
      .subscribe(data => {
        if (data) {
         this.user_data = data;
         this.baseService.user = data;
        }
      });
  }

  toogle(index: number, href: string): void {
    if (index === this.currentItem) {
      this.currentItem = null;
    } else {
      this.currentItem = index;
    }
  }

}



// WEBPACK FOOTER //
// D:/padriana/gorent-panel/src/app/dashboard/layout/nav/nav.component.ts